<template>
	<div
		id="partnership-modal"
		class="modal fade"
		tabindex="1"
		aria-labelledby="partnership-modal"
		@keyup.esc.stop.prevent="CloseModal()"
	>
		<div class="modal-dialog modal-dialog-centered">
			<div class="modal-content">
				<GridLayout
					:reactive-sidebar="false"
					:sidebar-state="false"
					class="full p-0"
				>
					<template #right-header>
						<div class="w-full h-full flex items-center gap-3 position-relative">
							<button
								class="btn btn-rounded"
								@click="Previous"
							>
								<i class="fas fa-chevron-left"></i>
							</button>
							<Steps
								:steps-map="stepsMap"
								:current-step="currentStep"
								@select-step="
									currentStep = $event
									autoNav = false
								"
							/>
							<div class="close-container">
								<button
									type="button"
									class="btn btn-tool"
									data-dismiss="modal"
									@click="CloseModal()"
								>
									<i class="far fa-times mx-1 font-24"></i>
								</button>
							</div>
						</div>
					</template>
					<template #right-content>
						<div class="w-full h-full flex flex-col items-center main-content">
							<Partnership
								v-if="step === 'partnership'"
								ref="partnership"
								class="w-full flex-1 flex flex-col"
								:modality_id="partnershipsProps.modality_id"
								:partnership="selected.partnership"
								:allowed_partnership_ids="partnershipsProps.allowed_partnership_ids"
								@next="WalkStep"
								@on-load-partnerships="partnerships = $event"
							/>

							<Guide
								v-if="step === 'guide'"
								ref="guide"
								class="w-full flex-1 flex flex-col"
								:modality_id="partnershipsProps.modality_id"
								:patient="patient"
								:partnerships="partnerships"
								:partnership="selected.partnership"
								:billing="selected.billing"
								:indicator="selected.indicator"
								:require_validation="true"
								@next="WalkStep"
								@billing-change="selected.billing = $event"
								@indicator-change="selected.indicator = $event"
							/>
						</div>
					</template>
					<template #right-footer>
						<div class="w-full h-full flex justify-between items-center">
							<button
								class="btn btn-danger btn-fixed-size"
								@click="CloseModal()"
							>
								CANCELAR
							</button>
							<button
								class="btn btn-success btn-fixed-size"
								@click="Continue()"
							>
								{{ step === 'partnership' ? 'CONTINUAR' : 'SALVAR' }}
							</button>
						</div>
					</template>
				</GridLayout>
			</div>
		</div>
	</div>
</template>

<script>
	import Partnership from '@/components/shared/scheduling/Partnership.vue'
	import Guide from '@/components/shared/scheduling/Guide.vue'
	export default {
		name: 'PartnershipsModal',
		components: {
			Partnership,
			Guide,
		},
		props: {
			partnershipsProps: {
				type: Object,
				required: true,
			},
			patient: {
				type: Object,
				default: null,
			},
		},
		data() {
			return {
				partnerships: [],
				currentStep: 0,
				autoNav: true,
				stepsMap: [
					{
						key: 'pre',
					},
					{
						key: 'partnership',
						number: 1,
						label: 'CONVÊNIO',
						isValid: false,
					},
					{
						key: 'guide',
						number: 2,
						label: 'GUIA',
						isValid: false,
					},
				],
				selected: {
					partnership: null,
					billing: null,
					indicator: null,
				},
			}
		},
		computed: {
			step() {
				return this.stepsMap[this.currentStep].key
			},
		},
		watch: {
			partnershipsProps: {
				handler(val) {
					if (val.partnership) this.selected.partnership = val.partnership
					if (val.billing) this.selected.billing = val.billing
					if (val.indicator) this.selected.indicator = val.indicator
				},
				immediate: true,
				deep: true,
			},
		},
		methods: {
			Previous() {
				switch (this.step) {
					case 'partnership':
						this.CloseModal()
						break
					case 'guide':
						this.currentStep--
						break
				}
			},
			WalkStep(param) {
				switch (this.step) {
					case 'pre':
						this.currentStep++
						break
					case 'partnership':
						this.selected.partnership = param.partnership

						this.stepsMap[this.currentStep].isValid = true
						this.currentStep++
						break
					case 'guide':
						this.selected.billing = param.billing
						this.selected.indicator = param.indicator

						this.stepsMap[this.currentStep].isValid = true
						this.Save(this.selected)
						break
				}
			},
			Continue() {
				if (this.step === 'partnership') {
					this.$refs.partnership.Continue()
				} else if (this.step === 'guide') {
					this.$refs.guide.Continue()
				}
			},
			CloseModal() {
				const $modal = window.jQuery('#partnership-modal')
				$modal.on('hidden.bs.modal', () => {
					window.jQuery('body').removeClass('modal-open')
					window.jQuery('.modal-backdrop').remove()
					$modal.off('hidden.bs.modal')
				})
				$modal.modal('hide')
				this.$emit('close')
			},
			Save(payload) {
				const $modal = window.jQuery('#partnership-modal')
				$modal.on('hidden.bs.modal', () => {
					window.jQuery('body').removeClass('modal-open')
					window.jQuery('.modal-backdrop').remove()
					$modal.off('hidden.bs.modal')
					this.$emit('save', payload)
				})
				$modal.modal('hide')
			},
		},
		mounted() {
			window.jQuery('#partnership-modal').modal({ focus: false })
			window.jQuery('#partnership-modal').modal('show')

			this.WalkStep()
		},
		beforeUnmount() {
			const $modal = window.jQuery('#partnership-modal')
			$modal.on('hidden.bs.modal', () => {
				window.jQuery('body').removeClass('modal-open')
				window.jQuery('.modal-backdrop').remove()
				$modal.off('hidden.bs.modal')
			})
			$modal.modal('hide')
		},
	}
</script>

<style lang="scss" scoped>
	#partnership-modal {
		.modal-dialog {
			max-width: 100vw;
			max-height: 100vh;
			margin: 0;

			.modal-content {
				height: 100vh;
				display: flex;
				flex-direction: column;
				align-items: center;
			}
		}

		.grid-layout input.form-control:focus {
			background-color: var(--backgroundColorActiveSelected);
		}
	}
</style>
